import _asyncToGenerator from "/codebuild/output/src2596793101/src/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/codebuild/output/src2596793101/src/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/codebuild/output/src2596793101/src/www/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { evalCondition } from "./mongrule.mjs";
import { chooseVariation, decrypt, getBucketRanges, getQueryStringOverride, getUrlRegExp, hash, inNamespace, inRange, isIncluded, isURLTargeted, toString } from "./util.mjs";
export var EVENT_FEATURE_EVALUATED = "Feature Evaluated";
export var EVENT_EXPERIMENT_VIEWED = "Experiment Viewed";
function getForcedFeatureValues(ctx) {
  // Merge user and global values
  var ret = new Map();
  if (ctx.global.forcedFeatureValues) {
    ctx.global.forcedFeatureValues.forEach(function (v, k) {
      return ret.set(k, v);
    });
  }
  if (ctx.user.forcedFeatureValues) {
    ctx.user.forcedFeatureValues.forEach(function (v, k) {
      return ret.set(k, v);
    });
  }
  return ret;
}
function getForcedVariations(ctx) {
  // Merge user and global values
  if (ctx.global.forcedVariations && ctx.user.forcedVariations) {
    return _objectSpread(_objectSpread({}, ctx.global.forcedVariations), ctx.user.forcedVariations);
  } else if (ctx.global.forcedVariations) {
    return ctx.global.forcedVariations;
  } else if (ctx.user.forcedVariations) {
    return ctx.user.forcedVariations;
  } else {
    return {};
  }
}
function safeCall(_x) {
  return _safeCall.apply(this, arguments);
}
function _safeCall() {
  _safeCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fn) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fn();
        case 3:
          _context.next = 7;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _safeCall.apply(this, arguments);
}
function onExperimentViewed(ctx, experiment, result) {
  // Make sure a tracking callback is only fired once per unique experiment
  if (ctx.user.trackedExperiments) {
    var k = getExperimentDedupeKey(experiment, result);
    if (ctx.user.trackedExperiments.has(k)) {
      return [];
    }
    ctx.user.trackedExperiments.add(k);
  }
  if (ctx.user.enableDevMode && ctx.user.devLogs) {
    ctx.user.devLogs.push({
      experiment: experiment,
      result: result,
      timestamp: Date.now().toString(),
      logType: "experiment"
    });
  }
  var calls = [];
  if (ctx.global.trackingCallback) {
    var cb = ctx.global.trackingCallback;
    calls.push(safeCall(function () {
      return cb(experiment, result, ctx.user);
    }));
  }
  if (ctx.user.trackingCallback) {
    var _cb = ctx.user.trackingCallback;
    calls.push(safeCall(function () {
      return _cb(experiment, result);
    }));
  }
  if (ctx.global.eventLogger) {
    var _cb2 = ctx.global.eventLogger;
    calls.push(safeCall(function () {
      return _cb2(EVENT_EXPERIMENT_VIEWED, {
        experimentId: experiment.key,
        variationId: result.key,
        hashAttribute: result.hashAttribute,
        hashValue: result.hashValue
      }, ctx.user);
    }));
  }
  return calls;
}
function onFeatureUsage(ctx, key, ret) {
  // Only track a feature once, unless the assigned value changed
  if (ctx.user.trackedFeatureUsage) {
    var stringifiedValue = JSON.stringify(ret.value);
    if (ctx.user.trackedFeatureUsage[key] === stringifiedValue) return;
    ctx.user.trackedFeatureUsage[key] = stringifiedValue;
    if (ctx.user.enableDevMode && ctx.user.devLogs) {
      ctx.user.devLogs.push({
        featureKey: key,
        result: ret,
        timestamp: Date.now().toString(),
        logType: "feature"
      });
    }
  }
  if (ctx.global.onFeatureUsage) {
    var cb = ctx.global.onFeatureUsage;
    safeCall(function () {
      return cb(key, ret, ctx.user);
    });
  }
  if (ctx.user.onFeatureUsage) {
    var _cb3 = ctx.user.onFeatureUsage;
    safeCall(function () {
      return _cb3(key, ret);
    });
  }
  if (ctx.global.eventLogger) {
    var _cb4 = ctx.global.eventLogger;
    safeCall(function () {
      return _cb4(EVENT_FEATURE_EVALUATED, {
        feature: key,
        source: ret.source,
        value: ret.value,
        ruleId: ret.source === "defaultValue" ? "$default" : ret.ruleId || "",
        variationId: ret.experimentResult ? ret.experimentResult.key : ""
      }, ctx.user);
    });
  }
}
export function evalFeature(id, ctx) {
  if (ctx.stack.evaluatedFeatures.has(id)) {
    process.env.NODE_ENV !== "production" && ctx.global.log("evalFeature: circular dependency detected: ".concat(ctx.stack.id, " -> ").concat(id), {
      from: ctx.stack.id,
      to: id
    });
    return getFeatureResult(ctx, id, null, "cyclicPrerequisite");
  }
  ctx.stack.evaluatedFeatures.add(id);
  ctx.stack.id = id;

  // Global override
  var forcedValues = getForcedFeatureValues(ctx);
  if (forcedValues.has(id)) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Global override", {
      id: id,
      value: forcedValues.get(id)
    });
    return getFeatureResult(ctx, id, forcedValues.get(id), "override");
  }

  // Unknown feature id
  if (!ctx.global.features || !ctx.global.features[id]) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Unknown feature", {
      id: id
    });
    return getFeatureResult(ctx, id, null, "unknownFeature");
  }

  // Get the feature
  var feature = ctx.global.features[id];

  // Loop through the rules
  if (feature.rules) {
    var evaluatedFeatures = new Set(ctx.stack.evaluatedFeatures);
    var _iterator = _createForOfIteratorHelper(feature.rules),
      _step;
    try {
      rules: for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var rule = _step.value;
        // If there are prerequisite flag(s), evaluate them
        if (rule.parentConditions) {
          var _iterator2 = _createForOfIteratorHelper(rule.parentConditions),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var parentCondition = _step2.value;
              ctx.stack.evaluatedFeatures = new Set(evaluatedFeatures);
              var parentResult = evalFeature(parentCondition.id, ctx);
              // break out for cyclic prerequisites
              if (parentResult.source === "cyclicPrerequisite") {
                return getFeatureResult(ctx, id, null, "cyclicPrerequisite");
              }
              var evalObj = {
                value: parentResult.value
              };
              var evaled = evalCondition(evalObj, parentCondition.condition || {});
              if (!evaled) {
                // blocking prerequisite eval failed: feature evaluation fails
                if (parentCondition.gate) {
                  process.env.NODE_ENV !== "production" && ctx.global.log("Feature blocked by prerequisite", {
                    id: id,
                    rule: rule
                  });
                  return getFeatureResult(ctx, id, null, "prerequisite");
                }
                // non-blocking prerequisite eval failed: break out of parentConditions loop, jump to the next rule
                process.env.NODE_ENV !== "production" && ctx.global.log("Skip rule because prerequisite evaluation fails", {
                  id: id,
                  rule: rule
                });
                continue rules;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        // If there are filters for who is included (e.g. namespaces)
        if (rule.filters && isFilteredOut(rule.filters, ctx)) {
          process.env.NODE_ENV !== "production" && ctx.global.log("Skip rule because of filters", {
            id: id,
            rule: rule
          });
          continue;
        }

        // Feature value is being forced
        if ("force" in rule) {
          // If it's a conditional rule, skip if the condition doesn't pass
          if (rule.condition && !conditionPasses(rule.condition, ctx)) {
            process.env.NODE_ENV !== "production" && ctx.global.log("Skip rule because of condition ff", {
              id: id,
              rule: rule
            });
            continue;
          }

          // If this is a percentage rollout, skip if not included
          if (!isIncludedInRollout(ctx, rule.seed || id, rule.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !rule.disableStickyBucketing ? rule.fallbackAttribute : undefined, rule.range, rule.coverage, rule.hashVersion)) {
            process.env.NODE_ENV !== "production" && ctx.global.log("Skip rule because user not included in rollout", {
              id: id,
              rule: rule
            });
            continue;
          }
          process.env.NODE_ENV !== "production" && ctx.global.log("Force value from rule", {
            id: id,
            rule: rule
          });

          // If this was a remotely evaluated experiment, fire the tracking callbacks
          if (rule.tracks) {
            rule.tracks.forEach(function (t) {
              var calls = onExperimentViewed(ctx, t.experiment, t.result);
              if (!calls.length && ctx.global.saveDeferredTrack) {
                ctx.global.saveDeferredTrack({
                  experiment: t.experiment,
                  result: t.result
                });
              }
            });
          }
          return getFeatureResult(ctx, id, rule.force, "force", rule.id);
        }
        if (!rule.variations) {
          process.env.NODE_ENV !== "production" && ctx.global.log("Skip invalid rule", {
            id: id,
            rule: rule
          });
          continue;
        }

        // For experiment rules, run an experiment
        var exp = {
          variations: rule.variations,
          key: rule.key || id
        };
        if ("coverage" in rule) exp.coverage = rule.coverage;
        if (rule.weights) exp.weights = rule.weights;
        if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
        if (rule.fallbackAttribute) exp.fallbackAttribute = rule.fallbackAttribute;
        if (rule.disableStickyBucketing) exp.disableStickyBucketing = rule.disableStickyBucketing;
        if (rule.bucketVersion !== undefined) exp.bucketVersion = rule.bucketVersion;
        if (rule.minBucketVersion !== undefined) exp.minBucketVersion = rule.minBucketVersion;
        if (rule.namespace) exp.namespace = rule.namespace;
        if (rule.meta) exp.meta = rule.meta;
        if (rule.ranges) exp.ranges = rule.ranges;
        if (rule.name) exp.name = rule.name;
        if (rule.phase) exp.phase = rule.phase;
        if (rule.seed) exp.seed = rule.seed;
        if (rule.hashVersion) exp.hashVersion = rule.hashVersion;
        if (rule.filters) exp.filters = rule.filters;
        if (rule.condition) exp.condition = rule.condition;

        // Only return a value if the user is part of the experiment
        var _runExperiment = runExperiment(exp, id, ctx),
          result = _runExperiment.result;
        ctx.global.onExperimentEval && ctx.global.onExperimentEval(exp, result);
        if (result.inExperiment && !result.passthrough) {
          return getFeatureResult(ctx, id, result.value, "experiment", rule.id, exp, result);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  process.env.NODE_ENV !== "production" && ctx.global.log("Use default value", {
    id: id,
    value: feature.defaultValue
  });

  // Fall back to using the default value
  return getFeatureResult(ctx, id, feature.defaultValue === undefined ? null : feature.defaultValue, "defaultValue");
}
export function runExperiment(experiment, featureId, ctx) {
  var key = experiment.key;
  var numVariations = experiment.variations.length;

  // 1. If experiment has less than 2 variations, return immediately
  if (numVariations < 2) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Invalid experiment", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 2. If the context is disabled, return immediately
  if (ctx.global.enabled === false || ctx.user.enabled === false) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Context disabled", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 2.5. Merge in experiment overrides from the context
  experiment = mergeOverrides(experiment, ctx);

  // 2.6 New, more powerful URL targeting
  if (experiment.urlPatterns && !isURLTargeted(ctx.user.url || "", experiment.urlPatterns)) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of url targeting", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 3. If a variation is forced from a querystring, return the forced variation
  var qsOverride = getQueryStringOverride(key, ctx.user.url || "", numVariations);
  if (qsOverride !== null) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Force via querystring", {
      id: key,
      variation: qsOverride
    });
    return {
      result: getExperimentResult(ctx, experiment, qsOverride, false, featureId)
    };
  }

  // 4. If a variation is forced in the context, return the forced variation
  var forcedVariations = getForcedVariations(ctx);
  if (key in forcedVariations) {
    var variation = forcedVariations[key];
    process.env.NODE_ENV !== "production" && ctx.global.log("Force via dev tools", {
      id: key,
      variation: variation
    });
    return {
      result: getExperimentResult(ctx, experiment, variation, false, featureId)
    };
  }

  // 5. Exclude if a draft experiment or not active
  if (experiment.status === "draft" || experiment.active === false) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because inactive", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 6. Get the hash attribute and return if empty
  var _getHashAttribute = getHashAttribute(ctx, experiment.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined),
    hashAttribute = _getHashAttribute.hashAttribute,
    hashValue = _getHashAttribute.hashValue;
  if (!hashValue) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because missing hashAttribute", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }
  var assigned = -1;
  var foundStickyBucket = false;
  var stickyBucketVersionIsBlocked = false;
  if (ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing) {
    var _getStickyBucketVaria = getStickyBucketVariation({
        ctx: ctx,
        expKey: experiment.key,
        expBucketVersion: experiment.bucketVersion,
        expHashAttribute: experiment.hashAttribute,
        expFallbackAttribute: experiment.fallbackAttribute,
        expMinBucketVersion: experiment.minBucketVersion,
        expMeta: experiment.meta
      }),
      _variation = _getStickyBucketVaria.variation,
      versionIsBlocked = _getStickyBucketVaria.versionIsBlocked;
    foundStickyBucket = _variation >= 0;
    assigned = _variation;
    stickyBucketVersionIsBlocked = !!versionIsBlocked;
  }

  // Some checks are not needed if we already have a sticky bucket
  if (!foundStickyBucket) {
    // 7. Exclude if user is filtered out (used to be called "namespace")
    if (experiment.filters) {
      if (isFilteredOut(experiment.filters, ctx)) {
        process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of filters", {
          id: key
        });
        return {
          result: getExperimentResult(ctx, experiment, -1, false, featureId)
        };
      }
    } else if (experiment.namespace && !inNamespace(hashValue, experiment.namespace)) {
      process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of namespace", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 7.5. Exclude if experiment.include returns false or throws
    if (experiment.include && !isIncluded(experiment.include)) {
      process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of include function", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 8. Exclude if condition is false
    if (experiment.condition && !conditionPasses(experiment.condition, ctx)) {
      process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of condition exp", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 8.05. Exclude if prerequisites are not met
    if (experiment.parentConditions) {
      var evaluatedFeatures = new Set(ctx.stack.evaluatedFeatures);
      var _iterator3 = _createForOfIteratorHelper(experiment.parentConditions),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var parentCondition = _step3.value;
          ctx.stack.evaluatedFeatures = new Set(evaluatedFeatures);
          var parentResult = evalFeature(parentCondition.id, ctx);
          // break out for cyclic prerequisites
          if (parentResult.source === "cyclicPrerequisite") {
            return {
              result: getExperimentResult(ctx, experiment, -1, false, featureId)
            };
          }
          var evalObj = {
            value: parentResult.value
          };
          if (!evalCondition(evalObj, parentCondition.condition || {})) {
            process.env.NODE_ENV !== "production" && ctx.global.log("Skip because prerequisite evaluation fails", {
              id: key
            });
            return {
              result: getExperimentResult(ctx, experiment, -1, false, featureId)
            };
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    // 8.1. Exclude if user is not in a required group
    if (experiment.groups && !hasGroupOverlap(experiment.groups, ctx)) {
      process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of groups", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }
  }

  // 8.2. Old style URL targeting
  if (experiment.url && !urlIsValid(experiment.url, ctx)) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of url", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 9. Get the variation from the sticky bucket or get bucket ranges and choose variation
  var n = hash(experiment.seed || key, hashValue, experiment.hashVersion || 1);
  if (n === null) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of invalid hash version", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }
  if (!foundStickyBucket) {
    var ranges = experiment.ranges || getBucketRanges(numVariations, experiment.coverage === undefined ? 1 : experiment.coverage, experiment.weights);
    assigned = chooseVariation(n, ranges);
  }

  // 9.5 Unenroll if any prior sticky buckets are blocked by version
  if (stickyBucketVersionIsBlocked) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because sticky bucket version is blocked", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId, undefined, true)
    };
  }

  // 10. Return if not in experiment
  if (assigned < 0) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because of coverage", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 11. Experiment has a forced variation
  if ("force" in experiment) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Force variation", {
      id: key,
      variation: experiment.force
    });
    return {
      result: getExperimentResult(ctx, experiment, experiment.force === undefined ? -1 : experiment.force, false, featureId)
    };
  }

  // 12. Exclude if in QA mode
  if (ctx.global.qaMode || ctx.user.qaMode) {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because QA mode", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 12.5. Exclude if experiment is stopped
  if (experiment.status === "stopped") {
    process.env.NODE_ENV !== "production" && ctx.global.log("Skip because stopped", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 13. Build the result object
  var result = getExperimentResult(ctx, experiment, assigned, true, featureId, n, foundStickyBucket);

  // 13.5. Persist sticky bucket
  if (ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing) {
    var _generateStickyBucket = generateStickyBucketAssignmentDoc(ctx, hashAttribute, toString(hashValue), _defineProperty({}, getStickyBucketExperimentKey(experiment.key, experiment.bucketVersion), result.key)),
      changed = _generateStickyBucket.changed,
      attrKey = _generateStickyBucket.key,
      doc = _generateStickyBucket.doc;
    if (changed) {
      // update local docs
      ctx.user.stickyBucketAssignmentDocs = ctx.user.stickyBucketAssignmentDocs || {};
      ctx.user.stickyBucketAssignmentDocs[attrKey] = doc;
      // save doc
      ctx.user.saveStickyBucketAssignmentDoc(doc);
    }
  }

  // 14. Fire the tracking callback(s)
  // Store the promise in case we're awaiting it (ex: browser url redirects)
  var trackingCalls = onExperimentViewed(ctx, experiment, result);
  if (trackingCalls.length === 0 && ctx.global.saveDeferredTrack) {
    ctx.global.saveDeferredTrack({
      experiment: experiment,
      result: result
    });
  }
  var trackingCall = !trackingCalls.length ? undefined : trackingCalls.length === 1 ? trackingCalls[0] : Promise.all(trackingCalls).then(function () {});

  // 14.1 Keep track of completed changeIds
  "changeId" in experiment && experiment.changeId && ctx.global.recordChangeId && ctx.global.recordChangeId(experiment.changeId);

  // 15. Return the result
  process.env.NODE_ENV !== "production" && ctx.global.log("In experiment", {
    id: key,
    variation: result.variationId
  });
  return {
    result: result,
    trackingCall: trackingCall
  };
}
function getFeatureResult(ctx, key, value, source, ruleId, experiment, result) {
  var ret = {
    value: value,
    on: !!value,
    off: !value,
    source: source,
    ruleId: ruleId || ""
  };
  if (experiment) ret.experiment = experiment;
  if (result) ret.experimentResult = result;

  // Track the usage of this feature in real-time
  if (source !== "override") {
    onFeatureUsage(ctx, key, ret);
  }
  return ret;
}
function getAttributes(ctx) {
  return _objectSpread(_objectSpread({}, ctx.user.attributes), ctx.user.attributeOverrides);
}
function conditionPasses(condition, ctx) {
  return evalCondition(getAttributes(ctx), condition, ctx.global.savedGroups || {});
}
function isFilteredOut(filters, ctx) {
  return filters.some(function (filter) {
    var _getHashAttribute2 = getHashAttribute(ctx, filter.attribute),
      hashValue = _getHashAttribute2.hashValue;
    if (!hashValue) return true;
    var n = hash(filter.seed, hashValue, filter.hashVersion || 2);
    if (n === null) return true;
    return !filter.ranges.some(function (r) {
      return inRange(n, r);
    });
  });
}
function isIncludedInRollout(ctx, seed, hashAttribute, fallbackAttribute, range, coverage, hashVersion) {
  if (!range && coverage === undefined) return true;
  if (!range && coverage === 0) return false;
  var _getHashAttribute3 = getHashAttribute(ctx, hashAttribute, fallbackAttribute),
    hashValue = _getHashAttribute3.hashValue;
  if (!hashValue) {
    return false;
  }
  var n = hash(seed, hashValue, hashVersion || 1);
  if (n === null) return false;
  return range ? inRange(n, range) : coverage !== undefined ? n <= coverage : true;
}
export function getExperimentResult(ctx, experiment, variationIndex, hashUsed, featureId, bucket, stickyBucketUsed) {
  var inExperiment = true;
  // If assigned variation is not valid, use the baseline and mark the user as not in the experiment
  if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
    variationIndex = 0;
    inExperiment = false;
  }
  var _getHashAttribute4 = getHashAttribute(ctx, experiment.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined),
    hashAttribute = _getHashAttribute4.hashAttribute,
    hashValue = _getHashAttribute4.hashValue;
  var meta = experiment.meta ? experiment.meta[variationIndex] : {};
  var res = {
    key: meta.key || "" + variationIndex,
    featureId: featureId,
    inExperiment: inExperiment,
    hashUsed: hashUsed,
    variationId: variationIndex,
    value: experiment.variations[variationIndex],
    hashAttribute: hashAttribute,
    hashValue: hashValue,
    stickyBucketUsed: !!stickyBucketUsed
  };
  if (meta.name) res.name = meta.name;
  if (bucket !== undefined) res.bucket = bucket;
  if (meta.passthrough) res.passthrough = meta.passthrough;
  return res;
}
function mergeOverrides(experiment, ctx) {
  var key = experiment.key;
  var o = ctx.global.overrides;
  if (o && o[key]) {
    experiment = Object.assign({}, experiment, o[key]);
    if (typeof experiment.url === "string") {
      experiment.url = getUrlRegExp(
      // eslint-disable-next-line
      experiment.url);
    }
  }
  return experiment;
}
export function getHashAttribute(ctx, attr, fallback) {
  var hashAttribute = attr || "id";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var hashValue = "";
  var attributes = getAttributes(ctx);
  if (attributes[hashAttribute]) {
    hashValue = attributes[hashAttribute];
  }

  // if no match, try fallback
  if (!hashValue && fallback) {
    if (attributes[fallback]) {
      hashValue = attributes[fallback];
    }
    if (hashValue) {
      hashAttribute = fallback;
    }
  }
  return {
    hashAttribute: hashAttribute,
    hashValue: hashValue
  };
}
function urlIsValid(urlRegex, ctx) {
  var url = ctx.user.url;
  if (!url) return false;
  var pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
  if (urlRegex.test(url)) return true;
  if (urlRegex.test(pathOnly)) return true;
  return false;
}
function hasGroupOverlap(expGroups, ctx) {
  var groups = ctx.global.groups || {};
  for (var i = 0; i < expGroups.length; i++) {
    if (groups[expGroups[i]]) return true;
  }
  return false;
}
function getStickyBucketVariation(_ref) {
  var ctx = _ref.ctx,
    expKey = _ref.expKey,
    expBucketVersion = _ref.expBucketVersion,
    expHashAttribute = _ref.expHashAttribute,
    expFallbackAttribute = _ref.expFallbackAttribute,
    expMinBucketVersion = _ref.expMinBucketVersion,
    expMeta = _ref.expMeta;
  expBucketVersion = expBucketVersion || 0;
  expMinBucketVersion = expMinBucketVersion || 0;
  expHashAttribute = expHashAttribute || "id";
  expMeta = expMeta || [];
  var id = getStickyBucketExperimentKey(expKey, expBucketVersion);
  var assignments = getStickyBucketAssignments(ctx, expHashAttribute, expFallbackAttribute);

  // users with any blocked bucket version (0 to minExperimentBucketVersion) are excluded from the test
  if (expMinBucketVersion > 0) {
    for (var i = 0; i <= expMinBucketVersion; i++) {
      var blockedKey = getStickyBucketExperimentKey(expKey, i);
      if (assignments[blockedKey] !== undefined) {
        return {
          variation: -1,
          versionIsBlocked: true
        };
      }
    }
  }
  var variationKey = assignments[id];
  if (variationKey === undefined)
    // no assignment found
    return {
      variation: -1
    };
  var variation = expMeta.findIndex(function (m) {
    return m.key === variationKey;
  });
  if (variation < 0)
    // invalid assignment, treat as "no assignment found"
    return {
      variation: -1
    };
  return {
    variation: variation
  };
}
function getStickyBucketExperimentKey(experimentKey, experimentBucketVersion) {
  experimentBucketVersion = experimentBucketVersion || 0;
  return "".concat(experimentKey, "__").concat(experimentBucketVersion);
}
export function getStickyBucketAttributeKey(attributeName, attributeValue) {
  return "".concat(attributeName, "||").concat(attributeValue);
}
function getStickyBucketAssignments(ctx, expHashAttribute, expFallbackAttribute) {
  if (!ctx.user.stickyBucketAssignmentDocs) return {};
  var _getHashAttribute5 = getHashAttribute(ctx, expHashAttribute),
    hashAttribute = _getHashAttribute5.hashAttribute,
    hashValue = _getHashAttribute5.hashValue;
  var hashKey = getStickyBucketAttributeKey(hashAttribute, toString(hashValue));
  var _getHashAttribute6 = getHashAttribute(ctx, expFallbackAttribute),
    fallbackAttribute = _getHashAttribute6.hashAttribute,
    fallbackValue = _getHashAttribute6.hashValue;
  var fallbackKey = fallbackValue ? getStickyBucketAttributeKey(fallbackAttribute, toString(fallbackValue)) : null;
  var assignments = {};
  if (fallbackKey && ctx.user.stickyBucketAssignmentDocs[fallbackKey]) {
    Object.assign(assignments, ctx.user.stickyBucketAssignmentDocs[fallbackKey].assignments || {});
  }
  if (ctx.user.stickyBucketAssignmentDocs[hashKey]) {
    Object.assign(assignments, ctx.user.stickyBucketAssignmentDocs[hashKey].assignments || {});
  }
  return assignments;
}
function generateStickyBucketAssignmentDoc(ctx, attributeName, attributeValue, assignments) {
  var key = getStickyBucketAttributeKey(attributeName, attributeValue);
  var existingAssignments = ctx.user.stickyBucketAssignmentDocs && ctx.user.stickyBucketAssignmentDocs[key] ? ctx.user.stickyBucketAssignmentDocs[key].assignments || {} : {};
  var newAssignments = _objectSpread(_objectSpread({}, existingAssignments), assignments);
  var changed = JSON.stringify(existingAssignments) !== JSON.stringify(newAssignments);
  return {
    key: key,
    doc: {
      attributeName: attributeName,
      attributeValue: attributeValue,
      assignments: newAssignments
    },
    changed: changed
  };
}
function deriveStickyBucketIdentifierAttributes(ctx, data) {
  var attributes = new Set();
  var features = data && data.features ? data.features : ctx.global.features || {};
  var experiments = data && data.experiments ? data.experiments : ctx.global.experiments || [];
  Object.keys(features).forEach(function (id) {
    var feature = features[id];
    if (feature.rules) {
      var _iterator4 = _createForOfIteratorHelper(feature.rules),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var rule = _step4.value;
          if (rule.variations) {
            attributes.add(rule.hashAttribute || "id");
            if (rule.fallbackAttribute) {
              attributes.add(rule.fallbackAttribute);
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  });
  experiments.map(function (experiment) {
    attributes.add(experiment.hashAttribute || "id");
    if (experiment.fallbackAttribute) {
      attributes.add(experiment.fallbackAttribute);
    }
  });
  return Array.from(attributes);
}
export function getAllStickyBucketAssignmentDocs(_x2, _x3, _x4) {
  return _getAllStickyBucketAssignmentDocs.apply(this, arguments);
}
function _getAllStickyBucketAssignmentDocs() {
  _getAllStickyBucketAssignmentDocs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ctx, stickyBucketService, data) {
    var attributes;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          attributes = getStickyBucketAttributes(ctx, data);
          return _context2.abrupt("return", stickyBucketService.getAllAssignments(attributes));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getAllStickyBucketAssignmentDocs.apply(this, arguments);
}
export function getStickyBucketAttributes(ctx, data) {
  var attributes = {};
  var stickyBucketIdentifierAttributes = deriveStickyBucketIdentifierAttributes(ctx, data);
  stickyBucketIdentifierAttributes.forEach(function (attr) {
    var _getHashAttribute7 = getHashAttribute(ctx, attr),
      hashValue = _getHashAttribute7.hashValue;
    attributes[attr] = toString(hashValue);
  });
  return attributes;
}
export function decryptPayload(_x5, _x6, _x7) {
  return _decryptPayload.apply(this, arguments);
}
function _decryptPayload() {
  _decryptPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, decryptionKey, subtle) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          data = _objectSpread({}, data);
          if (!data.encryptedFeatures) {
            _context3.next = 14;
            break;
          }
          _context3.prev = 2;
          _context3.t0 = JSON;
          _context3.next = 6;
          return decrypt(data.encryptedFeatures, decryptionKey, subtle);
        case 6:
          _context3.t1 = _context3.sent;
          data.features = _context3.t0.parse.call(_context3.t0, _context3.t1);
          _context3.next = 13;
          break;
        case 10:
          _context3.prev = 10;
          _context3.t2 = _context3["catch"](2);
          console.error(_context3.t2);
        case 13:
          delete data.encryptedFeatures;
        case 14:
          if (!data.encryptedExperiments) {
            _context3.next = 27;
            break;
          }
          _context3.prev = 15;
          _context3.t3 = JSON;
          _context3.next = 19;
          return decrypt(data.encryptedExperiments, decryptionKey, subtle);
        case 19:
          _context3.t4 = _context3.sent;
          data.experiments = _context3.t3.parse.call(_context3.t3, _context3.t4);
          _context3.next = 26;
          break;
        case 23:
          _context3.prev = 23;
          _context3.t5 = _context3["catch"](15);
          console.error(_context3.t5);
        case 26:
          delete data.encryptedExperiments;
        case 27:
          if (!data.encryptedSavedGroups) {
            _context3.next = 40;
            break;
          }
          _context3.prev = 28;
          _context3.t6 = JSON;
          _context3.next = 32;
          return decrypt(data.encryptedSavedGroups, decryptionKey, subtle);
        case 32:
          _context3.t7 = _context3.sent;
          data.savedGroups = _context3.t6.parse.call(_context3.t6, _context3.t7);
          _context3.next = 39;
          break;
        case 36:
          _context3.prev = 36;
          _context3.t8 = _context3["catch"](28);
          console.error(_context3.t8);
        case 39:
          delete data.encryptedSavedGroups;
        case 40:
          return _context3.abrupt("return", data);
        case 41:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 10], [15, 23], [28, 36]]);
  }));
  return _decryptPayload.apply(this, arguments);
}
export function getApiHosts(options) {
  var defaultHost = options.apiHost || "https://cdn.growthbook.io";
  return {
    apiHost: defaultHost.replace(/\/*$/, ""),
    streamingHost: (options.streamingHost || defaultHost).replace(/\/*$/, ""),
    apiRequestHeaders: options.apiHostRequestHeaders,
    streamingHostRequestHeaders: options.streamingHostRequestHeaders
  };
}
export function getExperimentDedupeKey(experiment, result) {
  return result.hashAttribute + result.hashValue + experiment.key + result.variationId;
}